import { combineReducers } from 'redux';

// Import the reducers
import app from './app.reducer';
import auth from './auth.reducer';
import errors from './errors.reducer';
import loaders from './loaders.reducer';

const rootReducer = combineReducers({
  app,
  auth,
  errors,
  loaders
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/app/state/reducers/index.js